var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("category-header", {
        attrs: {
          title: _vm.title,
          active: _vm.dropdownVisible,
          loading: _vm.loading
        },
        on: { click: _vm.onToggleBar }
      }),
      _vm._v(" "),
      _vm.dropdownVisible
        ? _c("ul", { staticClass: "group-category" }, [
            _c("li", [_vm._t("default")], 2)
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }